/**
 * This is the model for the ExternalReference Collections.
 * This is used to show external references paired to a user experience.
 */
export interface ExternalReference {
  readonly id: number;
  readonly contextId: number;
  readonly contextType: ExternalReferenceContextTypeEnum;
  readonly authorUserId: number;
  readonly relationship: string;
  readonly content: string;
  readonly deletedDate?: number | null;
}

export enum ExternalReferenceContextTypeEnum {
  EXPERIENCE = 'experience',
  UNASSIGNED = 'unassigned',
}
